import { toast } from 'sonner';
import { api } from 'trpc/react';
import { withConfirmation } from '~/entities/Confirmation';
import { useInvalidateAll } from '~/features/Cache';
import TrashIcon from '~/shared/assets/icons/trash.svg';
import { TooltipAction, type TooltipActionProps } from '~/shared/ui/TooltipAction';

type DeleteProductsActionProps = TooltipActionProps & {
    onOpenChange: (open: boolean, clear?: boolean) => void;
    products: ReadonlyArray<{ id: string }>;
};

export const DeleteProductsAction = ({ open, index, onOpenChange, products }: DeleteProductsActionProps) => {
    const ids = products.map(p => p.id);

    const { mutate: invalidateAll } = useInvalidateAll();

    const { mutate } = api.product.deleteMany.useMutation({
        onMutate: () => {
            toast.loading('Удаляем товары...', { id: 'deleteMany' });
        },
        onSuccess: async data => {
            invalidateAll();
            onOpenChange(false, true);
            toast.success(`Успешно удалено товаров: ${data?.deleted}`, { id: 'deleteMany' });
        },
        onError: () => {
            toast.error('Не удалось удалить товары', { id: 'deleteMany' });
        },
    });

    return (
        <TooltipAction open={open} index={index}>
            <button
                type='button'
                className='block h-full w-full p-2'
                onClick={withConfirmation(
                    () => mutate({ ids }),
                    `Это действие необратимо удалит все выбранные товары (штук: ${ids.length}), их изображения, черновики и очистит кэш, связанный с ними.`,
                )}
            >
                <TrashIcon className='h-full w-full stroke-red-500' />
            </button>
        </TooltipAction>
    );
};
